import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  dialogPaper: {
    padding: spacing(2, 3),
    maxHeight: '95%',
    maxWidth: 1440,
    minWidth: 900
  },
  dialogTitle: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: spacing(3),
    padding: spacing(2, 0)
  },
  actionBtnCtn: {
    paddingBottom: spacing(1)
  },
  cancelBtn: {
    marginRight: 16,
    minWidth: 100,
    textTransform: 'none'
  },
  saveBtn: { minWidth: 100 },
  input: {
    marginTop: spacing(2)
  },
  helperText: {
    textAlign: 'right'
  },
  inputGroup: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  },
  inputStyle: {
    width: 405,
    marginLeft: 10,
    marginRight: 10
  },
  removeBtn: {
    width: 190
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))
